import Typography from '@alltrails/core/components/Typography';
import LinksColumn from '@alltrails/seo/components/LinksColumn';
import MinimizedSeoLinksGrid from '@alltrails/seo/components/MinimizedSeoLinksGrid/MinimizedSeoLinksGrid';
import type { SeoLinkItem } from '@alltrails/types/SeoLinkItem';
import { DEFAULT_MAX_LINKS_PER_SECTION } from '../seoLinksHelpers';
import styles from './DesktopLinkSection.module.scss';

type DesktopLinkSectionProps = {
  title: string;
  links: SeoLinkItem[];
  isBot?: boolean;
  seoTestAddTrailsToLocationLinks?: boolean;
  seoTestAddHikingTrailsToLocationLinks?: boolean;
  seoTestMinimizeSeoLinks?: boolean;
};

const DesktopLinkSection = ({
  title,
  links,
  isBot = false,
  seoTestAddTrailsToLocationLinks,
  seoTestAddHikingTrailsToLocationLinks,
  seoTestMinimizeSeoLinks
}: DesktopLinkSectionProps) => {
  const firstBatch = links.slice(0, 8);
  const secondBatch = links.slice(8, DEFAULT_MAX_LINKS_PER_SECTION);

  return (
    <div>
      <Typography variant="heading200" component="h3" mt="0" className={styles.title}>
        {title}
      </Typography>
      <div className={styles.linkBlockColumns}>
        {seoTestMinimizeSeoLinks ? (
          <MinimizedSeoLinksGrid
            variant="seolinks"
            linkItems={links}
            firstColumnSize={8}
            maxLayoutLinks={DEFAULT_MAX_LINKS_PER_SECTION}
            columnContainerClassName={styles.linksColumn}
            isBot={isBot}
            seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
            seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
          />
        ) : (
          <>
            <div className={styles.linksColumn}>
              <LinksColumn
                links={firstBatch}
                seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
                seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
              />
            </div>
            {!!secondBatch.length && (
              <div className={styles.linksColumn}>
                <LinksColumn
                  links={secondBatch}
                  seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
                  seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DesktopLinkSection;
